module.exports = __webpack_public_path__ + "static/public_calendars_1-f04b5b42a67a86cfe330b53df940fcfc.png";